
export class GasThree  {
    constructor(_Id?: number, _SettlementPrice?: number, _StripName?: string) {       

        this.Id = _Id;        
        this.SettlementPrice = _SettlementPrice;
        this.StripName = _StripName;      
    }

    public Id: number;  
    public SettlementPrice: number;
    public StripName: string;   
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/models/gasthree.model.ts